import * as React from 'react';
import { IAIcon } from '../icon/Icon'
import * as styles from './peopleCard.css';
import { Helper } from './../../Helper';

interface IPeopleProperty {
  property: string;
  value: string;
  iconTitle?: string;
  iconColor?: string;
  iconSize?: number;
}
interface IPeopleCardProps {
  properties: IPeopleProperty[];
  image?: string;
  backgroundColor: string;
  linkedTextColor?: string;
  index?: number;
  nameLink?: string;
  floatImage?:boolean;
  styles?:any;
}

interface ICredentialValue {
  value?: string;
  iconTitle?: string;
  iconColor?: string;
  iconSize?: number;
  classNames?: any[];
  link?: string;
}

interface IUserCredentials {
  PREFERREDNAME?: ICredentialValue;
  WORKEMAIL?: ICredentialValue;
  WORKPHONE?: ICredentialValue;
  MOBILEPHONE?: ICredentialValue;
  DEPARTMENT?: ICredentialValue;
  JOBTITLE?: ICredentialValue;
}

export class IAPeopleCard extends React.Component<IPeopleCardProps>{

  assignCredentialsToUser = (properties: IPeopleProperty[]): IUserCredentials => {
    let credentialsUser = {
    };
    properties.map((property) => {
      let linkTo: string;
      if (property.property === "PreferredName") { linkTo = this.props.nameLink; }
      if (property.property === "WorkEmail" || property.property === "WorkPhone") { linkTo = `tel:${property.value}` }
      if (property.property) {
        let propertyName = property.property?.toUpperCase();
        Object.defineProperty(credentialsUser, propertyName, {
          value: {
            value: property.value,
            iconTitle: property.iconTitle,
            iconColor: property.iconColor,
            iconSize: property.iconSize,
            classNames: property.property === "PreferredName" ? [styles.IA_credential_name, styles.IA_credentials_dots] : [styles.IA_credentials_dots],
            link: linkTo
          },
          enumerable: true
        });
      }
    })
    return credentialsUser;
  }

  getLink = (parentObject: IUserCredentials, key: string): string => {
    if (parentObject && parentObject[key]) {
      if (parentObject[key] && key === "PREFERREDNAME") {
        return 'PREFERREDNAME';
      } if (parentObject[key] && key === "WORKEMAIL") {
        return `mailto:${parentObject[key].value}`;
      } if (parentObject[key] && key === "MOBILEPHONE" || key === "WORKPHONE") {
        return `tel:${parentObject[key].value}`;
      } if (parentObject[key] && key === "TEAMSCHAT") {
        return `https://teams.microsoft.com/l/chat/0/0?users=${parentObject[key].value}`;
      } else {
        return "";
      }
    } else {
      return undefined;
    }
  }

  render() {
    let credentialElements: JSX.Element[] = [];
    let firstNameChar: string = undefined;
    let lastNameChar: string = undefined;
    if (this.props.properties && this.props.properties.length > 0) {

      let credentialsUser = this.assignCredentialsToUser(this.props.properties);
      if (credentialsUser) {
        for (let variable in credentialsUser) {
          let linkTo = this.getLink(credentialsUser, variable);
          if (credentialsUser[variable] !== undefined && credentialsUser[variable] !== null) {
            if (variable === 'PREFERREDNAME') {
              let fullName: string = credentialsUser[variable].value;
              let firstName: string = fullName.split(' ')[0];
              let lastName: string = fullName.split(' ')[fullName.split(' ').length - 1];
              firstNameChar = firstName[0];
              lastNameChar = firstName !== lastName ? lastName[0] : firstName[1];
            }
            credentialElements.push(
              <div className={styles.IA_item} key={`card:${this.props.index}${variable}`}>
                {variable !== 'PREFERREDNAME' && credentialsUser[variable] && credentialsUser[variable].iconTitle &&
                  <div className={styles.IA_credential_icons}>
                    <IAIcon
                      title={credentialsUser[variable].iconTitle ? credentialsUser[variable].iconTitle : "star"}
                      size={credentialsUser[variable].iconSize ? credentialsUser[variable].iconSize : 20}
                      color={credentialsUser[variable].iconColor ? credentialsUser[variable].iconColor : "#8b0000"}
                    />
                  </div>
                }
                <div className={credentialsUser[variable].classNames ? credentialsUser[variable].classNames.join(' ') : ""}>
                  {linkTo && variable === "PREFERREDNAME" && this.props.nameLink &&
                    <a style={{ textDecoration: "none", color: this.props.linkedTextColor ? this.props.linkedTextColor : '#8b0000' }} href={this.props.nameLink} target="_blank">
                      {credentialsUser[variable].value}
                    </a>}
                  {linkTo && linkTo !== "PREFERREDNAME" && linkTo !== "" &&
                    <a style={{ textDecoration: "none", color: this.props.linkedTextColor ? this.props.linkedTextColor : '#8b0000' }} href={linkTo}>
                      {credentialsUser[variable].value}
                    </a>}
                  {(linkTo === "" || (linkTo === "PREFERREDNAME" && !this.props.nameLink)) && <div className={variable === "PREFERREDNAME" ? "" : credentialsUser[variable].classNames.join(' ')}>
                    {credentialsUser[variable].value}
                  </div>}
                </div>
              </div>
            )
          }
        }

      }
    }
    return (
      <div className={styles.IA_peopleCard}>
        <div
          className={styles.IA_personaSmallProfileImageWrapper}
          style={{
            backgroundColor: this.props.backgroundColor != undefined ? this.props.backgroundColor : "#333333",
            color: this.props.backgroundColor != undefined ? Helper.getTextColorBasedOnBackgroundColorDarkness(this.props.backgroundColor, "#ffffff", "#333333") : "#ffffff",
            float: !this.props.floatImage || !this.props.floatImage ? "left" : "none",
            marginRight: !this.props.floatImage || !this.props.floatImage ? "25px" : "auto",
            marginLeft: !this.props.floatImage || !this.props.floatImage ? "10px" : "auto",            
          }}
        >
          <div className={styles.IA_personaSmallProfileImageText}>
            {firstNameChar + lastNameChar}
          </div>
          <div
            className={styles.IA_personaSmallProfileImage}
            style={{
              backgroundImage: `url('${this.props.image ? this.props.image : ""}')`
            }}
          />
        </div>
        <div className={styles.IA_peopleCard_content} >
          {credentialElements}
        </div>
      </div>);
  }
}            